import request from "@/common/request"
import { Estoque, EstoqueProjection, Page } from "@/models"
import { AxiosRequestConfig } from "axios"

const basePath = '/estoques'

export const findEstoques = (params?: any, config?: AxiosRequestConfig): Promise<Page<Estoque>> =>
	request.get(`${basePath}`, {
		params: {
			...params,
		},
		...config,
	})

export const findOtimizado = (params?: any, config?: AxiosRequestConfig): Promise<Page<EstoqueProjection>> =>
	request.get(`${basePath}/lista`, {
		params,
		...config,
	})


export const salvarRomaneio = async (

): Promise<any> => 
	request.post("/romaneio")